// removed by extract-text-webpack-plugin
module.exports = {"CurrentPriceField":"CurrentPriceField","currentPrice":"currentPrice","Ref":"Ref","Floor":"Floor","Ceil":"Ceil","SpaceBetween":"SpaceBetween","PriceTitle":"PriceTitle","PriceInfoLeft":"PriceInfoLeft","PriceInfoRight":"PriceInfoRight"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/OrderForm/CurrentPriceField/styles.scss
// module id = 1960
// module chunks = 10